import { Amount } from "./../entity/price-entity/price-action.types";
import { OrderLevelDiscount, ProductLevelDiscount } from "../entity/discount.types";
import { PriceCode } from "../entity/price-code";

export const generateAmountCondition = (
    amount: number,
    selectedDiscount: OrderLevelDiscount | ProductLevelDiscount,
    priceCode: PriceCode
): Amount => {
    switch (selectedDiscount) {
        case OrderLevelDiscount.PERCENTAGE_OFF:
        case ProductLevelDiscount.PERCENTAGE_OFF:
            return {
                multiply: {
                    expressions: [
                        {
                            ref: {
                                price_code: priceCode,
                                default_value: {
                                    constant: "0",
                                    minimum: "",
                                    maximum: "",
                                },
                            },
                            minimum: "",
                            maximum: "",
                        },
                        {
                            constant: `-${Number(amount / 100).toFixed(4)}`,
                            minimum: "",
                            maximum: "",
                        },
                    ],
                },
                minimum: "",
                maximum: "",
            };
        case OrderLevelDiscount.AMOUNT_OF:
            return {
                constant: `${-amount}`,
                minimum: "",
                maximum: "",
            };
        case OrderLevelDiscount.FREE_SHIPPING:
            return {
                multiply: {
                    expressions: [
                        {
                            numeric_field: {
                                expression: "cart.?details.?estimated_shipping_costs.?total",
                                default_value: {
                                    constant: "0",
                                    minimum: "",
                                    maximum: "",
                                },
                            },
                            minimum: "",
                            maximum: "",
                        },
                        {
                            constant: "-1",
                            minimum: "",
                            maximum: "",
                        },
                    ],
                },
            };
        case ProductLevelDiscount.AMOUNT_OFF_EACH:
            return {
                multiply: {
                    expressions: [
                        {
                            constant: `${-amount}`,
                            minimum: "",
                            maximum: "",
                        },
                        {
                            qty: {},
                            minimum: "",
                            maximum: "",
                        },
                    ],
                },
            };
        case OrderLevelDiscount.NET_TERMS_EXTENSION:
            return {
                constant: "0",
                minimum: "",
                maximum: "",
            };
    }
};
